module.exports = __webpack_public_path__ + "img/logo1.43a22726.png";